module.exports = __webpack_public_path__ + "img/bell-off.984ca8d3.svg";